/**
 * The Django permissions the frontend reads off `/users/me/`. Each one only
 * decides what the UI shows; the API behind it keeps its own check. All are
 * granted in the Django admin.
 */

/** Show the Settings > Feature Flags tab. */
export const VIEW_SETTINGS_FEATURE_FLAGS_TAB_PERMISSION =
  "core.view_settings_feature_flags_tab";

/** Show the Settings > Cache tab. */
export const VIEW_SETTINGS_CACHE_TAB_PERMISSION =
  "core.view_settings_cache_tab";
